import axios from 'axios';
import debounce from 'debounce-promise';
import handleRequestError from './HandleRequestError';
import { AutoCompleteLocation } from '../types/auto-complete';

export const endpoint =
  process.env.REACT_APP_API_ENDPOINT || 'http://localhost:3000';

const instance = axios.create({
  baseURL: endpoint,
  timeout: 1000 * 60,
  headers: { 'Content-Type': 'application/json' },
});

const withToken = (token: string | null | undefined) =>
  !token ? {} : { headers: { auth_token: token } };

export const get = <T, E, D>(path: string, data?: D, token?: string | null) =>
  instance
    .get<T>(`/api/4${path}`, { params: data, ...withToken(token) })
    .then<T>(response => response.data)
    .catch<E>(error => {
      handleRequestError(error);
      return error;
    });

export const post = <T, E>(path: string, data: any, token?: string | null) =>
  instance
    .post<T>(`/api/4${path}`, data, withToken(token) as any)
    .then<T>(response => response.data)
    .catch<E>(error => {
      handleRequestError(error);
      return error;
    });

export const autocomplete = debounce(
  (searchString: string, countryCode: string = 'AU') =>
    instance
      .get<Array<AutoCompleteLocation>>(
        `/autocomplete/combined?term=${searchString}&country_code=${countryCode}`
      )
      .then(response => response.data),
  800
);

export const carrierGatewayGet = async (
  path: string,
  params?: any,
  config?: RequestInit
) => {
  let paramString;

  if (params) {
    const searchParams = new URLSearchParams(params);
    paramString = `?${searchParams.toString()}`;
  }

  const requestUrl = [
    process.env.REACT_APP_CARRIER_GATEWAY_BASE_URL,
    path,
    paramString,
  ].join('');

  return fetch(requestUrl, config).then(async response => response.json());
};
